(function () {
	const initCollapsibleContent = () => {
		document.querySelectorAll('.collapsible-content__toggle').forEach(function (toggle) {
			if (toggle._ccInit) return;
			toggle._ccInit = true;

			toggle.addEventListener('click', function () {
				const parent = this.parentElement;
				const items = this.closest('.collapsible-content__items');

				if (!parent.classList.contains('active')) {
					items.querySelectorAll('.collapsible-content__item.active').forEach(function (el) {
						el.classList.remove('active');
					});
					parent.classList.add('active');
				} else {
					parent.classList.remove('active');
				}
			});
		});

		document.querySelectorAll('.collapsible-content__item').forEach(function (item) {
			if (item._ccMouseInit) return;
			item._ccMouseInit = true;

			item.addEventListener('mouseenter', function () {
				this.classList.remove('collapsible-content__item--opacity');
				Array.from(this.parentElement.children).forEach(function (sib) {
					if (sib !== item) sib.classList.add('collapsible-content__item--opacity');
				});
			});

			item.addEventListener('mouseleave', function () {
				Array.from(this.parentElement.children).forEach(function (sib) {
					sib.classList.remove('collapsible-content__item--opacity');
				});
			});
		});
	};

	document.addEventListener('shopify:section:load', function () {
		initCollapsibleContent();
	});

	initCollapsibleContent();
})();
